import request from '@/utils/request'

// 部门列表
export const getDepartmentList = () => request({
  url: '/workOnLine/employ/open/department/list',
  method: 'get'
})
// 分类列表
export const getCategoryList = () => request({
  url: '/workOnLine/employ/open/category/list',
  method: 'get'
})
// 服务列表
export const getServiceList = (data) => request({
  url: '/workOnLine/employ/open/getEmployList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})